import type { SVGProps } from "react";
export interface LocationOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function LocationOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: LocationOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 10.547V10c0-3.63-3.095-6.875-6.876-6.875a6.64 6.64 0 0 0-2.994.716 1.125 1.125 0 0 1-1.01-2.01 8.9 8.9 0 0 1 4.004-.956c5.057 0 9.126 4.286 9.126 9.125v.547c0 1.26-.257 2.461-.672 3.577a1.124 1.124 0 1 1-2.11-.782c.338-.909.532-1.845.532-2.795m-5.954-4.564.113.023.268.078a4.13 4.13 0 0 1 2.612 2.612l.079.266.023.113a1.126 1.126 0 0 1-2.166.563l-.034-.11-.08-.239a1.89 1.89 0 0 0-1.026-1.025l-.239-.08-.11-.035a1.125 1.125 0 0 1 .56-2.166M2.205 2.205a1.125 1.125 0 0 1 1.505-.078l.085.078 18 18 .078.085a1.125 1.125 0 0 1-1.584 1.583l-.084-.078-2.773-2.773a26.6 26.6 0 0 1-3.677 3.49 2.83 2.83 0 0 1-3.51 0c-1.128-.883-2.944-2.452-4.487-4.481-1.438-1.891-2.714-4.28-2.868-6.946l-.015-.537v-.547c0-1.564.425-3.063 1.16-4.375l-1.83-1.83-.078-.086a1.125 1.125 0 0 1 .078-1.505m2.92 8.343.012.409c.119 2.04 1.108 3.997 2.411 5.712 1.382 1.816 3.035 3.25 4.083 4.07a.584.584 0 0 0 .738 0 24.2 24.2 0 0 0 3.467-3.312l-3.335-3.335a4 4 0 0 1-.501.034 4.125 4.125 0 0 1-4.093-4.628L5.711 7.302a6.6 6.6 0 0 0-.586 2.699z"
      />
    </svg>
  );
}
